import { v4 as uuid } from 'uuid';
import { validate } from 'parameter-validator';
import permissions from '../../Apollo/permissions';
import useMutationWithBaseOptions from './useMutationWithBaseOptions';
import {
  mutation as insertPipelineMutation,
  buildVariables as buildInsertVariables,
} from './insert-pipeline-mutation-builder';

export default function useInsertPipeline(options) {
  const [executeMutation, response] = useMutationWithBaseOptions(insertPipelineMutation, {
    ...options,
    successMsg: 'New pipeline added.',
    context: { permission: permissions.createPipeline },
  });

  const insertPipeline = args => {
    validate(args, ['name', 'writekey', 'clusterId']);
    return executeMutation(buildVariables(args));
  };
  return [insertPipeline, response];
}

function buildVariables(args) {
  const id = uuid();
  return {
    variables: buildInsertVariables({ id, ...args }),
  };
}
